import React from 'react';
import { Helmet } from 'react-helmet-async';

export const Seo = ({
  title,
  description,
  type = 'website',
  name = 'Cambridge Carpenter',
  canonical,
  image = '/cambridge-carpenter.png',
  schema,
  noindex = false,
}) => {
  const siteBase = 'https://www.cambridgecarpenter.co.uk';
  const fullImage = image && (image.startsWith('http') ? image : `${siteBase}${image.startsWith('/') ? '' : '/'}${image}`);
  const schemaBlocks = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical && <meta property="og:url" content={canonical} />}
      {fullImage && <meta property="og:image" content={fullImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {fullImage && <meta name="twitter:image" content={fullImage} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {schemaBlocks.map((block, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};
